import { Link } from "react-router-dom";

/**
 * The Reliserve Wealth Journal masthead — appears on the listing page and above
 * every article for a consistent publication feel.
 */
export default function JournalMasthead({ compact = false }) {
  return (
    <div
      className={`border-b hairline ${compact ? "pb-4" : "py-6"} mb-8`}
      data-testid="journal-masthead"
    >
      <div className="flex items-center justify-between">
        <Link to="/journal" className="block group" data-testid="journal-masthead-title">
          <div className="eyebrow">Est. 2026</div>
          <div className="font-display text-2xl md:text-3xl text-ink leading-tight mt-1 group-hover:text-brass-deep transition-colors">
            The Reliserve Wealth <em className="text-brass-deep not-italic">Journal</em>
          </div>
        </Link>
        <div className="hidden md:block eyebrow text-right">
          Practical notes on wealth,<br />protection & planning
        </div>
      </div>
    </div>
  );
}
